import React, { useEffect } from "react";
import { useParams } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import { getRecurringEvent } from "../../store/selectors";
import { getRecurringEvent as getRecurringEventAction } from "../../store/actions";
import { NamesOfParentRoutes } from "../../../../constants";

import { IRouteProps } from "shared";

const { STREAM } = NamesOfParentRoutes;

const EventRecurringContainer: React.FC = () => {
  const { eventId } = useParams<IRouteProps>();

  const dispatch = useDispatch();
  const history = useHistory();
  const recurringEvent = useSelector(getRecurringEvent());

  useEffect(() => {
    if (recurringEvent) {
      history.replace(`${STREAM}/${recurringEvent.code}`);
      dispatch(getRecurringEventAction.cancel());
    }
  }, [dispatch, history, recurringEvent]);

  useEffect(() => {
    if (eventId) {
      dispatch(getRecurringEventAction.request({ eventIdentifier: Number(eventId) }));
    }
  }, [dispatch, eventId]);

  return null;
};

export default EventRecurringContainer;
